<template>
	<view class="noticeDetail-wrap">
		<!-- <pageNav title="通知" :isHavBack="isHavBack"></pageNav> -->
		<view class="noticeDetail-main">
			<view class="noticeDetail-title">
				<view class="zheng-title">{{title}}</view>
				<view class="fu-title">{{createTime}}</view>
			</view>
			<view class="noticeDetail-content">
				<view class="content" v-html="content">
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				title:'',
				content:'',
				createTime:''
			}
		},
		onLoad(option) {
			this.createTime = decodeURIComponent(option.createTime)
			this.title = decodeURIComponent(option.title)
			this.content = decodeURIComponent(option.content)
		}
	}
</script>

<style lang="scss" scoped>
	.noticeDetail-main{
		width: 100%;
		padding: 32rpx;
		box-sizing: border-box;
	}
	.noticeDetail-title{
		display: flex;
		flex-direction: column;
		padding-bottom: 20rpx;
		border-bottom: 1px dotted #BCBCBC;
		.zheng-title{
			font-size: 36rpx;
			color: #666666;
			font-weight: light;
			text-align: center;
			line-height: 2;
		}
		.fu-title{
			font-size: 28rpx;
			color: #666666;
			font-weight: light;
			text-align: center;
			line-height: 2;
		}
	}
	.noticeDetail-content{
		margin-top: 40rpx;
		text-indent: 2em;
		.content{
			font-size: 32rpx;
			color: #666666;
			font-weight: light;
			line-height: 2;
		}
		
	}
</style>
